var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChatMessage',{attrs:{"createdBy":_vm.createdBy,"me":_vm.isMe,"message":_vm.message}})}
var staticRenderFns = []

export { render, staticRenderFns }